module.exports = __webpack_public_path__ + "img/pro-m-slider6.4840d3d4.png";